import React from 'react'
import Index from '../_components/Project/Index'

const Project = () => {
  return (
    <Index />
  )
}

export default Project